import displayReport from './display-report';

export default function(action, page){
  if(action === 'displayreport') {
    displayReport();
  }
}